






























import { Component, Vue } from 'vue-property-decorator'
import { ActionAssignToType, ActionType, DelayUnit, ReferralOrigin, TriggerType } from '@/api/types'
import { TriggeredAction } from '@/api/model/triggered-action'
import { v4 as uuid } from 'uuid'

@Component
export default class TriggeredActionCreate extends Vue {
    triggeredAction: TriggeredAction = null
    loading: boolean = false

    async mounted() {
        this.loading = true
        this.createNewTriggeredAction()
        this.loading = false
    }

    createNewTriggeredAction() {
        this.triggeredAction = new TriggeredAction(
            this.$currentCompany,
            uuid(),
            TriggerType.change,
            this.$currentCompany.pipelinesEnabled ? 'phase' : 'status',
            null,
            null,
            1,
            DelayUnit.minute,
            null,
            null,
            ReferralOrigin.internal,
            ActionType.EMAIL,
            null,
            [],
            ActionAssignToType.assignedTo,
            '',
            null,
            null,
            null,
            null,
            new Date(),
            new Date(),
        )
    }

    async goBackToLister(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_virtual_colleague_triggered_action',
        })
    }
}
